<div class="admin-content-header d-flex flex-column flex-sm-row justify-content-between">
  <div class="title">
    <h1 class="header-title">
      {{ isInternal ? "القيود الداخلية" : "القيود الخارجية " }}
    </h1>
  </div>
  <div ngbDropdown>
    <button [qcId]="'export-btn'" type="button" class="btn DS btn-outline-green d-flex" id="dropdownBasic1" ngbDropdownToggle>
      <i class="fa-solid fa-file-arrow-down"></i>
      <span> إصدار تقرير </span>
    </button>
    <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="reports text-light">
      <button [qcId]="'export-excel'" ngbDropdownItem (click)="exportAdminFranchisesAsExcel()">
        <i class="fa-regular fa-file-spreadsheet"></i>
        <span> إصدار بصيغة Excel</span>
      </button>
      <button [qcId]="'export-pdf'" ngbDropdownItem (click)="exportAdminFranchisesAsPdf()">
        <i class="fa-solid fa-file-pdf"></i>
        <span>إصدار بصيغة PDF</span>
      </button>
    </div>
  </div>
</div>
<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a>
        <i class="d-inline-block fa-regular fa-house-blank"></i>
        <span> الرئيسية</span>
      </a>
    </li>
    <li class="breadcrumb-item"><a>قيود الامتياز</a></li>
    <li class="breadcrumb-item active" aria-current="page">
      {{ isInternal ? "القيود الداخلية" : "القيود الخارجية " }}
    </li>
  </ol>
</nav>
<div class="tabs">
  <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
    <li [ngbNavItem]="1">
      <a ngbNavLink [qcId]="'filter-all'" (click)="this.SetActiveTab(1); changeStatus(true);">الكل </a>
      <ng-template ngbNavContent>
        <app-franchise-admin-tab [showStatus]="true" [franchises]="franchises"
          (reloadGrid)="refreshGrid($event)"></app-franchise-admin-tab>
      </ng-template>
    </li>
    <li [ngbNavItem]="2">
      <div #navContent></div>
      <a ngbNavLink [qcId]="'filter-active'" (click)="this.SetActiveTab(2); changeStatus(true);">القيود النشطة</a>
      <ng-template ngbNavContent>
        <app-franchise-admin-tab [showStatus]="false" [franchises]="franchises"
          (reloadGrid)="refreshGrid($event)"></app-franchise-admin-tab>
      </ng-template>
    </li>
    <li [ngbNavItem]="3">
      <a ngbNavLink [qcId]="'filter-suspended'" (click)="this.SetActiveTab(3); changeStatus(true);"> القيود الموقوفة</a>
      <ng-template ngbNavContent>
        <app-franchise-admin-tab [showStatus]="false" [franchises]="franchises"
          (reloadGrid)="refreshGrid($event)"></app-franchise-admin-tab>
      </ng-template>
    </li>
    <li [ngbNavItem]="4">
      <a ngbNavLink [qcId]="'filter-violated'" (click)="this.SetActiveTab(4); changeStatus(true);">القيود المخالفة</a>
      <ng-template ngbNavContent>
        <app-franchise-admin-tab [showStatus]="false" [franchises]="franchises"
          (reloadGrid)="refreshGrid($event)"></app-franchise-admin-tab>
      </ng-template>
    </li>
    <li [ngbNavItem]="5">
      <a ngbNavLink [qcId]="'filter-cancelled'" (click)="this.SetActiveTab(5); changeStatus(true);"> القيود الملغية </a>
      <ng-template ngbNavContent>
        <app-franchise-admin-tab [showStatus]="false" [franchises]="franchises"
          (reloadGrid)="refreshGrid($event)"></app-franchise-admin-tab>
      </ng-template>
    </li>
    <li [ngbNavItem]="6">
      <a ngbNavLink [qcId]="'filter-expired'" (click)="this.SetActiveTab(6); changeStatus(true);"> القيود المنتهية </a>
      <ng-template ngbNavContent>
        <app-franchise-admin-tab [showStatus]="false" [franchises]="franchises"
          (reloadGrid)="refreshGrid($event)"></app-franchise-admin-tab>
      </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>